/**
 * Wraps a react component display name with a hoc name
 */

function getDisplayName(Component: React.ComponentType<any>) {
	if (typeof Component === 'string') {
		return Component;
	}

	if (!Component) {
		return undefined;
	}

	return Component.displayName || Component.name || 'Component';
}

export default function wrapDisplayName(BaseComponent: React.ComponentType<any>, hocName: string) {
	return `${hocName}(${getDisplayName(BaseComponent)})`;
}
